import { Row, Col, Alert, Button } from 'antd';
import config from '../../../config';
import { useTranslation } from 'react-i18next';

const DisclaimerEdition = ({ reservation }) => {
  const { t } = useTranslation();

  return (
    <Row justify="center" className="mt-40">
      <Col lg={12}>
        <Alert
          message={
            <div>
              <div>
                {t('reservations.disclaimerEdition.text')}
              </div>
              <div className="mt-10 mb-10">
                <Row>
                  <Col lg={10}>
                    <a target="_blank" rel="noreferrer" href={`https://${config.redirectedFromSage}/departments/${reservation.department_id}/reservations/${reservation.id}/edit`}>
                      <Button type="primary" className="cmt-button secondary" size="large">
                        {t('reservations.disclaimerEdition.editButton')}
                      </Button>
                    </a>
                  </Col>
                </Row>
              </div>
            </div>
          }
          type="info" />
      </Col>
    </Row>
  )
}

export default DisclaimerEdition;